import {Types} from "../../../../../type/Types";

export namespace PlaceFunnelAnalyticsValueObject {

export type Stats = {
    placeSummaryId: bigint,
    placeId: bigint,
    adminId: bigint | null,
    isActive: boolean,
    exposedAt: Date,
    placeMissionType: number,
    placeNumber: string | null,
    placeName: string | null,
    placeImageUrl: string | null,
    placeTelephoneNumber: string | null,
    answer: string | null,
    placeUrl: string | null,
    attractionNameString: string | null,
    keywordString: string | null,
    amount: number | null,
    amountBeforeRefresh: number | null,
    successCount: number,
    failureCount: number,
    reportCount: number,
    postBackSuccessCount: number,
    verifiedPostBackCount: number,
    unverifiedPostBackCount: number,
    missionClickCount: number,
    clipBoardClickCount: number,
    answerSubmitClickCount: number,
    participationMethodClickCount: number,
    anotherMissionClickCount: number,
    missionEntryPageCount: number,
    participationSuccessPageLandingCount: number,
    rewardFailurePageLandingCount: number,
    deactivatedPathJointCount: number,
    activatedPathJointCount: number,
    createdAt: Date
    modifiedAt: Date | null
    crawlerHandledAt: Date | null
    deletedAt: Date | null
}

export type TotalStats = {
    exposedAt: Date,
    placeErrorFunnelStatsId: bigint,
    amount: number,
    successCount: number,
    failureCount: number,
    reportCount: number,
    postBackSuccessCount: number,
    exhaustedPageLandingCount: number,
    todayParticipationLimitPageLandingCount: number,
    serverErrorPageLandingCount: number,
    verifiedPostBackCount: number,
    unverifiedPostBackCount: number,
    missionClickCount: number,
    clipBoardClickCount: number,
    answerSubmitClickCount: number,
    participationMethodClickCount: number,
    anotherMissionClickCount: number,
    missionEntryPageCount: number,
    participationSuccessPageLandingCount: number,
    rewardFailurePageLandingCount: number
}

    export namespace Stats {
        export function construct(o: any): Stats {
            return {
                placeSummaryId: BigInt(o.placeSummaryId),
                placeId: BigInt(o.placeId),
                adminId: BigInt(o.adminId),
                isActive: Boolean(o.isActive),
                exposedAt: new Date(o.exposedAt),
                placeMissionType: Number(o.placeMissionType),
                placeNumber: Types.asNull(o.placeNumber, String),
                placeName: Types.asNull(o.placeName, String),
                placeImageUrl: Types.asNull(o.placeImageUrl, String),
                placeTelephoneNumber: Types.asNull(o.placeTelephoneNumber, String),
                answer: Types.asNull(o.answer, String),
                placeUrl: Types.asNull(o.placeUrl, String),
                attractionNameString: Types.asNull(o.attractionNameString, String),
                keywordString: Types.asNull(o.keywordString, String),
                amount: Types.asNull(o.amount, Number),
                amountBeforeRefresh: Types.asNull(o.amountBeforeRefresh, Number),
                successCount: Number(o.successCount),
                failureCount: Number(o.failureCount),
                reportCount: Number(o.reportCount),
                postBackSuccessCount: Number(o.postBackSuccessCount),
                verifiedPostBackCount: Number(o.verifiedPostBackCount),
                unverifiedPostBackCount: Number(o.unverifiedPostBackCount),
                missionClickCount: Number(o.missionClickCount),
                clipBoardClickCount: Number(o.clipBoardClickCount),
                answerSubmitClickCount: Number(o.answerSubmitClickCount),
                participationMethodClickCount: Number(o.participationMethodClickCount),
                anotherMissionClickCount: Number(o.anotherMissionClickCount),
                missionEntryPageCount: Number(o.missionEntryPageCount),
                participationSuccessPageLandingCount: Number(o.participationSuccessPageLandingCount),
                rewardFailurePageLandingCount: Number(o.rewardFailurePageLandingCount),
                deactivatedPathJointCount: Number(o.deactivatedPathJointCount),
                activatedPathJointCount: Number(o.activatedPathJointCount),
                createdAt: new Date(o.createdAt),
                modifiedAt: Types.asNull(o.modifiedAt, o => new Date(o)),
                crawlerHandledAt: Types.asNull(o.crawlerHandledAt, o => new Date(o)),
                deletedAt: Types.asNull(o.deletedAt, o => new Date(o))
            }
        }

        export const description: Record<keyof Stats, string> = {
            placeSummaryId: '플레이스 Summary ID',
            placeId: '플레이스 ID',
            adminId: '관리자 ID',
            isActive: '활성 여부',
            exposedAt: '노출 일자',
            placeMissionType: '미션 종류',
            placeNumber: '플레이스 번호',
            placeName: '이름',
            placeImageUrl: '이미지 URL',
            placeTelephoneNumber: '전화번호',
            answer: '정답',
            placeUrl: 'URL',
            attractionNameString: '명소',
            keywordString: '키워드',
            amount: '수량',
            amountBeforeRefresh: '부활 전 수량',
            successCount: '성공',
            failureCount: '실패',
            reportCount: '신고',
            postBackSuccessCount: '포스트백 성공',
            verifiedPostBackCount: '검증된 포스트백',
            unverifiedPostBackCount: '검증되지 않은 포스트백',
            missionClickCount: '미션클릭',
            clipBoardClickCount: '클립보드 복사',
            answerSubmitClickCount: '정답제출',
            participationMethodClickCount: '참여하기',
            anotherMissionClickCount: '다른미션가져오기',
            missionEntryPageCount: '미션페이지',
            participationSuccessPageLandingCount: '참여성공페이지',
            rewardFailurePageLandingCount: '적립실패페이지',
            deactivatedPathJointCount: '비활성화 경로 Joint',
            activatedPathJointCount: '활성화 경로 Joint',
            createdAt: '생성 일자',
            modifiedAt: '수정 일자',
            crawlerHandledAt: '크롤러 응답 데이터 마지막 핸들 날짜',
            deletedAt: '삭제 일자'
        }
    }

    export namespace TotalStats {
        export function construct(o: any): TotalStats {
            return {
                exposedAt: new Date(o.exposedAt),
                placeErrorFunnelStatsId: BigInt(o.placeErrorFunnelStatsId),
                amount: Number(o.amount),
                successCount: Number(o.successCount),
                failureCount: Number(o.failureCount),
                reportCount: Number(o.reportCount),
                postBackSuccessCount: Number(o.postBackSuccessCount),
                exhaustedPageLandingCount: Number(o.exhaustedPageLandingCount),
                todayParticipationLimitPageLandingCount: Number(o.todayParticipationLimitPageLandingCount),
                serverErrorPageLandingCount: Number(o.serverErrorPageLandingCount),
                verifiedPostBackCount: Number(o.verifiedPostBackCount),
                unverifiedPostBackCount: Number(o.unverifiedPostBackCount),
                missionClickCount: Number(o.missionClickCount),
                clipBoardClickCount: Number(o.clipBoardClickCount),
                answerSubmitClickCount: Number(o.answerSubmitClickCount),
                participationMethodClickCount: Number(o.participationMethodClickCount),
                anotherMissionClickCount: Number(o.anotherMissionClickCount),
                missionEntryPageCount: Number(o.missionEntryPageCount),
                participationSuccessPageLandingCount: Number(o.participationSuccessPageLandingCount),
                rewardFailurePageLandingCount: Number(o.rewardFailurePageLandingCount),
            }
        }

        export const description: Record<keyof TotalStats, string> = {
            exposedAt: '노출 일자',
            placeErrorFunnelStatsId: '플레이스 에러 통계 Stats ID',
            amount: '수량',
            successCount: '성공',
            failureCount: '실패',
            reportCount: '신고',
            postBackSuccessCount: '포스트백 성공',
            exhaustedPageLandingCount: '소진페이지',
            todayParticipationLimitPageLandingCount: '오늘참여제한페이지',
            serverErrorPageLandingCount: '서버에러페이지',
            verifiedPostBackCount: '검증된 포스트백',
            unverifiedPostBackCount: '검증되지 않은 포스트백',
            missionClickCount: '미션클릭',
            clipBoardClickCount: '클립보드 복사',
            answerSubmitClickCount: '정답제출',
            participationMethodClickCount: '참여하기',
            anotherMissionClickCount: '다른미션가져오기',
            missionEntryPageCount: '미션페이지',
            participationSuccessPageLandingCount: '참여성공페이지',
            rewardFailurePageLandingCount: '적립실패페이지',
        }
    }
}
